import {Injectable} from "@angular/core";
import {AppService} from "@irb/app.service";
import {IrbModelsEvents} from "@irb/irb-models/irb-models.events";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {IrbAppEvents} from "@irb/app.events";
import {interval, map, Observable, of, Subscription} from "rxjs";
import {Router} from "@angular/router";



@Injectable({
  providedIn: "root"
})
export class MmcInventoryActionsService {

  selectedModels: any = [];
  notSubscribedModels: any = [];
  paidForSubscribe: any = [];
  manFeeAccountNumber: any = null;
  isUiTest = false;
  progressTimer: any;
  subscribedModelMarketIds: Array<number> = [];
  goBlendAfterSubscribe = false;
  goExistedBlendAfterSubscribe = false;
  disclosuresMap: any;
  editSlideSlot: any;
  customModelDisclosure: any = null;
  validationMessages: Array<any>;
  mmcServiceUrlPrefix = '/mmc';

  httpOptions: any = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    })
  };

  constructor(public _http: HttpClient,
              private as: AppService,
              private router: Router) {
      const useModelMarketService = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_MMC_APIS || false;
      if (useModelMarketService)
            this.mmcServiceUrlPrefix = '/model-market-service';
  }

  subscribeFlowStart(selectedModels: any, _validationMessages: any = null) {
    this.clearSubscribeFlow();
    this.selectedModels = selectedModels;
    this.validationMessages = _validationMessages;
    this.pickModelsForSubscribe(selectedModels);
  }

  pickModelsForSubscribe(selectedModels: any) {
    this.notSubscribedModels = selectedModels.filter((m: any) => m.isSubscribed === false);

    if (this.notSubscribedModels.length === 0) {
      selectedModels.forEach((model: any) => {
        this.subscribedModelMarketIds.push(model.modelMarketId);
      });

      if(this.goBlendAfterSubscribe || this.goExistedBlendAfterSubscribe)
        this.goToBlendFlow();
      else {
        this.openSubscribeTrain(true);
      }

      return;
    }
    this.paidForSubscribe = this.notSubscribedModels.filter((m: any) => m.isPaidForModel === true);

    if (this.paidForSubscribe.length) {
      this.checkAgreement();
    } else {
      this.checkForProvidersDisclosures();
    }

  }

  checkAgreement() {
    this.checkSundryAuthorization().subscribe((res: any) => {
      const response = res && res.data ? res.data.irebalResponse : res; //irebalResponse got boolean response
      if (response) {
        this.manFeeAccountNumber = this.paidForSubscribe[0].sundryAccountNumber;
        this.checkForProvidersDisclosures();
      } else
        this.as.fireEvent(IrbModelsEvents.SHOW_MAN_FEE_AGREEMENT);
    });
  }

  checkForProvidersDisclosures() {
    let providersId: any = [], notRequiredDisclosureProvider: any = [],
    isCustom = false, isProvidesDislosure = false;
    this.customModelDisclosure = null;
    this.disclosuresMap = null;

    this.notSubscribedModels.forEach((model: any) => {
      if (model.firmDisclosureRequired) {
        isProvidesDislosure = true;
        if (!providersId.includes(model.modelProviderId))
          providersId.push(model.modelProviderId);
      } else {
        if (!notRequiredDisclosureProvider.includes(model.modelProviderId))
          notRequiredDisclosureProvider.push(model.modelProviderId);
      }
      if (model.usedFor === 'custom') {
        isCustom = true;
        if (!providersId.includes(model.modelProviderId))
          providersId.push(model.modelProviderId);
      }
    });

    if (isProvidesDislosure) {
      this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
      this.getDisclosures(providersId.join(','), isCustom).subscribe((resp: any) => {
        this.disclosuresMap = this.checkIsDisclosureRequired(notRequiredDisclosureProvider, resp);
        if (isCustom) {
          this.customModelDisclosure = resp.schwabDisclosure;
          delete this.disclosuresMap.schwabDisclosure
        }
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
        this.openSubscribeTrain();
      }, () => {
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      });
    } else {
      if (isCustom) {
        this.getCustomDisclosures(providersId);
      } else {
        this.openSubscribeTrain();
      }
    }
  }

  checkIsDisclosureRequired(notRequiredDisclosureProvider: any, resp: any) {
    if (notRequiredDisclosureProvider.length) {
      notRequiredDisclosureProvider.forEach((providerId: any) => {
        if (resp && resp[providerId]) {
          delete resp[providerId];
        }
      });
    }
    return resp;

  }

  getCustomDisclosures(providersId: any) {
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    this.customModelDisclosure = null;
    this.getDisclosures(providersId.join(','), true).subscribe((resp: any) => {
      if (resp && resp.schwabDisclosure) {
        this.customModelDisclosure = resp.schwabDisclosure;
      }
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.openSubscribeTrain();
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      this.openSubscribeTrain();
    });
  }


  sundryPassGoNext(manFeeAccountNumber: any) {
    this.paidForSubscribe.forEach((model: any) => { model.sundryAccountNumber = manFeeAccountNumber;});
    this.manFeeAccountNumber = manFeeAccountNumber;
    this.checkForProvidersDisclosures();
  }

  clearSubscribeFlow() {
    this.subscribedModelMarketIds = [];
    this.selectedModels = [];
    this.notSubscribedModels = [];
    this.paidForSubscribe = [];
    this.manFeeAccountNumber = null;
    if (this.progressTimer)
      clearTimeout(this.progressTimer);
  }

  goToBlendFlow() {
    this.getModelIdsFromMMC(this.subscribedModelMarketIds).subscribe((response: any) => {
      if (response.responseStatus === 'SUCCESS') {
        const modelIds = response.responseData;
        this.router.navigate(['/models/models']);
        if (this.goExistedBlendAfterSubscribe)
          this.as.fireEvent(IrbModelsEvents.SHOW_ADD_TO_EXISTING_BLENDED_MODELS, {modelIds: modelIds});
        else
          this.as.fireEvent(IrbModelsEvents.SHOW_CREATE_BLENDED_MODELS, {modelIds: modelIds});
      } else {
        this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
          severity: 'error',
          summary: 'Error',
          detail: 'An error occurred processing your request.'
        });
      }
    });
    this.goBlendAfterSubscribe = false;
  }



  checkSundryAuthorization() {
     let url = `/model-market-service/check-sundry-authorization`;
    return this._http.get(url, this.httpOptions); // can't use defineResponse method here because the response is a boolean, not an object with irebalResponse
  }

  getDisclosures(providersId: any, isCustom: boolean = false) {
    let url = `/model-market-service/provider/disclosures?providerids=` + providersId;
    if (isCustom)
      url += '&schwabDisclosure=true'
    return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
  }

  subscribeModelsAsync(data: any): Observable<Object> {
    let url = `${this.mmcServiceUrlPrefix}/async/subscribe/models`;
    return this._http.post(url, JSON.stringify(data), this.httpOptions).pipe(map(res => this.defineResponse(res)));
  }

  actionStatusCheck(statusId: any) {
    let url = `${this.mmcServiceUrlPrefix}/async/async-response-list/${statusId}`;
    return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
  }

  getModelIdsFromMMC(data: any): Observable<Object> {
     let url = `/model-market-service/mmc-advisor-model-ids`;
    return this._http.post(url, JSON.stringify(data), this.httpOptions).pipe(map(res => this.defineResponse(res)));
  }

  openSubscribeTrain(allSubscribed = false) {

    if (!this.manFeeAccountNumber) {
      this.paidForSubscribe = this.selectedModels.filter((m: any) => m.isPaidForModel === true);
      if (this.paidForSubscribe.length) {
        this.manFeeAccountNumber = this.paidForSubscribe[0].sundryAccountNumber;
      }
    }

    const passedData: any = {
      selectedModels: this.selectedModels,
      manFeeAccountNumber: this.manFeeAccountNumber,
      disclosuresMap: this.disclosuresMap,
      goBlendAfterSubscribe: this.goBlendAfterSubscribe,
      goExistedBlendAfterSubscribe: this.goExistedBlendAfterSubscribe,
      allSubscribed: allSubscribed,
      editSlideSlot: this.editSlideSlot,
      customModelDisclosure: this.customModelDisclosure,
      validationMessages: this.validationMessages
    }
    this.as.fireEvent(IrbModelsEvents.SHOW_SUBSCRIBE_TRAIN, passedData);
  }

  // getCustomModelDisclosures(_providersId: any) {
  //   //return this._http.get('/mmc/provider/custom-disclosures?providerids=' + _providersId, this.httpOptions)
  //   let r = {
  //     data: {
  //       id: 1,
  //       type: 'custom model disclosures',
  //       irebalResponse: {
  //         '111': 'THIS IS custom model DISCLOSURE'
  //       }
  //     }
  //   }
  //   return of(r);
  // }

      defineResponse(res: any) {
        return  res && res.data && res.data.irebalResponse ? res.data.irebalResponse : res;
    }
}
